import { abbrNumberVisitsWithNullOrUndefinedFilter, decimalNumberFilter } from "app/filters/ngFilters";

export function visitsFormatter() {
    return (num: number) => {
        return abbrNumberVisitsWithNullOrUndefinedFilter()(num) || "N/A";
    };
}

export function pagesPerVisitsFormatter() {
    return (num: number) => {
        return decimalNumberFilter()(num, true) || "N/A";
    };
}
